import "../i18nFallback";
import "../sentryInstrumentReact";
import React from 'react';

import { formatBackorderMessage } from "./storeLogic/storeStateManager";


const defaultWebpThumbnail = "https://dummyimage.com/120x120/000/fff.jpg";
const defaultThumbnail = "https://dummyimage.com/120x120/000/fff.jpg";

function ShoppingCartRow({
  itemClass = "cart-row",
  id, 
  quantity, 
  variantDetails,
  productDetails,
  handleQuantityInputChange,
  handleQuantityIncrease, 
  handleQuantityDecrease, 
  handleRemoveProduct,
  handleOnBlur,
  handleOnKeyUp,
  error
}) {
  const {
    title, 
    slug, 
    type,
    image,
    thumbnail,
    webpThumbnail,
  } = productDetails;

  const {
    minimum_quantity,
    maximum_quantity,
    is_on_sale,
    price,
    current_price,
    retail_price,
    quantity_break_ranges,
    quantity_break_prices,
    backordering,
    quantity: variantQuantity,
    attributes,
  } = variantDetails;

  let errorStyle;
  if (isNaN(quantity) || error) {
    errorStyle = {borderColor: 'red'}
  }
  let salePrice; 
  if (is_on_sale) {
    salePrice = current_price;
  } else {
    salePrice = price || retail_price;
  }
  let fullPrice = retail_price || price;
  const parsedQuantity = parseInt(quantity, 10);

  if ( quantity_break_ranges.length > 0) {
    for (let i = 0; i < quantity_break_ranges.length; i++) {
      const range = quantity_break_ranges[i].split("-");
      const lowerBound = parseInt(range[0], 10);
      const upperBound = parseInt(range[1], 10);
      if (
        (parsedQuantity >= lowerBound && parsedQuantity <= upperBound) ||
        (parsedQuantity >= lowerBound && isNaN(upperBound))
      ) {
        salePrice = quantity_break_prices[i];
        break;
      } 
    }
  }
  const cleanSalePrice = parseFloat(salePrice).toFixed(2);
  const cleanFullPrice = parseFloat(fullPrice).toFixed(2);
  
  // figure out if backorder message applies
  const backorderMessage = formatBackorderMessage(
    quantity,
    variantQuantity,
    backordering,
    variantDetails.downloadable
  );

  // Build the display title with variant attributes
  const hasAttributes = attributes && Object.values(attributes).some(Boolean);
  const displayTitle = hasAttributes ?
    `${title} - ${Object.values(attributes).join(' - ')}` :
    title;

  return (
    <div className={itemClass}>
      <div className="product-image-wrap">
        <a href={window.gettext('/store/product/') + slug} title={`visit the product page for ${title}`}>
          <picture>
            {webpThumbnail ? <source srcSet={webpThumbnail} type="image/webp" /> : null}
            <img loading="lazy" src={thumbnail ? thumbnail : defaultThumbnail} alt="" width="120" />
          </picture>
        </a>
      </div>
      <div className="product-info">
        <h2>{displayTitle}</h2>
        <p className="price">
          <strong>${cleanSalePrice}</strong> &nbsp;
          {parseFloat(fullPrice) > parseFloat(salePrice) && (<small className='full-price'><span className='sale-price'>${cleanFullPrice}</span></small>)}
        </p>
        <div className="cart-options">
          <div 
            className="cart-counter" 
            style={errorStyle}
          >
            <button title={window.gettext("Subtract")}
              disabled={parseInt(quantity) <= parseInt(minimum_quantity) || isNaN(quantity)}
              className="minus cart-btn" 
              onClick={handleQuantityDecrease}
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                height="16px"
                width="16px"
                className="icon icon--counter"
              >
                <path d="M17 11a1 1 0 010 2H7a1 1 0 010-2h10z" />
              </svg>
            </button>
            <input 
              type="number" 
              id="quantity" 
              pattern="[0-9]*"
              className="qty text" 
              name={id} 
              value={quantity.toString()} 
              onChange={handleQuantityInputChange} 
              onBlur={handleOnBlur}
              onKeyUp={handleOnKeyUp}
              aria-label="Product quantity" 
              size="4" 
              step="1" 
              min={minimum_quantity}
              max={maximum_quantity}
              placeholder="" 
              autoComplete="off"
              readOnly={parseInt(maximum_quantity) === 1}
            />
            <button title={window.gettext("Add")}
              disabled={parseInt(quantity) >= parseInt(maximum_quantity) || isNaN(quantity)}
              className="plus cart-btn" 
              onClick={handleQuantityIncrease}
            >
              <svg
                fill="currentColor"
                viewBox="0 0 16 16"
                height="16px"
                width="16px"
                className="icon icon--counter"
              >
                <path d="M8 4a.5.5 0 01.5.5v3h3a.5.5 0 010 1h-3v3a.5.5 0 01-1 0v-3h-3a.5.5 0 010-1h3v-3A.5.5 0 018 4z" />
              </svg>
            </button>
          </div>
          <a className="cart-btn cart-btn--trash" onClick={handleRemoveProduct} title={window.gettext("Remove")}>
            <svg className="icon"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>
          </a>
        </div>
        {backorderMessage !== null && 
          <div>
            <p className="alert alert-warning mt-1">{backorderMessage}</p>
          </div>
        }
        {error && <div style={{borderColor: 'red', color: 'red'}}>{error}</div>}
      </div>
    </div>
  );
}

export default ShoppingCartRow;
